import {Link} from "#/src/components/Link";
import {BrandLogo} from "#/src/components/BrandLogo";

export function Content() {
  return <section className="register-wrapper pt-4">
    <div className="container p-0 h-100">
      <div className="row g-0 h-100">
        <div className="col-xl-12">
          <div className="login-brand text-center">
            <Link href="/">
              <BrandLogo/>
            </Link>
          </div>
        </div>
        <div className="col-12 mx-auto my-auto mb-5">
          <div className="panel mt-4">
            <div className="panel-title text-white">
              <h1 className="basic-headline mb-2">
                Regulamin portalu Ja, Rock!
              </h1>
              <p>
                Regulamin usługi świadczonej drogą elektroniczną w zakresie prowadzenia konta Ja, Rock!
                Niniejszy Regulamin wchodzi w życie z dniem publikacji — 06 września 2024 roku.
              </p>
              <h2 className={"basic-headline mb-2"}>SŁOWNICZEK DEFINICJI</h2>
              <ol>
                <li>
                  W niniejszym regulaminie zwanym dalej „Regulaminem”, pod poniższymi pojęciami należy rozumieć: JaRock Sp. z o.o. - JaRock Spółka z ograniczoną odpowiedzialnością z siedzibą we Wrocławiu, przy ul. Marszałka Józefa Piłsudskiego 74/320, 50-020 Wrocław, wpisaną do Krajowej Rejestru Przedsiębiorców pod numerem KRS 0000909653, posiadającą numer NIP 8971893878.
                </li>
                <li>
                  Usługa — pakiet świadczeń będących usługami elektronicznymi w rozumieniu ustawy z dnia 18 lipca 2002 r. o świadczeniu usług drogą elektroniczną obejmujący Konto Użytkownika oraz jego dodatkowe funkcjonalności w szczególności:
                  <ol type={"a"}>
                    <li>
                      Serwisu, świadczona na warunkach Regulaminu. Usługa polega na zapewnieniu bezpłatnego dostępu do pełnych zasobów i funkcjonalności Serwisu tj. oglądania transmisji live stream, czytania bloga, publikowana treści oraz możliwość komentowania
                    </li>
                    <li>
                      Konto Użytkownika — dane komputerowe w bazie danych JaRock Sp. z o.o. określona unikalnym identyfikatorem, dostępna przez Internet po dokonaniu autoryzacji wraz z mechanizmami umożliwiającymi zarządzanie danymi identyfikacyjnymi i korzystanie z Serwisu.
                    </li>
                    <li>
                      Umowa — umowa zawarta na świadczenie Usługi na warunkach Regulaminu.
                    </li>
                    <li>
                      Serwis — system stron WWW dostępny w pełnej funkcjonalności za pośrednictwem Konta Użytkownika pod adresem https://www.jarock.pl/ i stronach powiązanych.
                    </li>
                    <li>
                      Komentarz — każda publikowana treść dotycząca Wpisu lub innych treści dostępnych w Serwisie.
                    </li>
                  </ol>
                </li>
              </ol>
              <h2 className={"basic-headline mb-2"}>POSTANOWIENIA OGÓLNE</h2>
              <ol>
                <li>
                  Konto Użytkownika umożliwia Użytkownikom:
                  <ol type={"a"}>
                    <li>zarządzanie danymi identyfikacyjnymi,</li>
                    <li>dostęp do Serwisu,</li>
                    <li>korzystanie z Serwisu.</li>
                  </ol>
                </li>
                <li>
                  Usługę obsługi konta świadczy JaRock Sp. z o.o.
                </li>
                <li>
                  Kontakt z JaRock Sp. z o.o. możliwy jest poprzez e-mail: <a href={"mailto:kontakt@jarock.pl"}>kontakt@jarock.pl</a>
                </li>
                <li>
                  Umowa jest zawierana na czas nieokreślony licząc od daty rejestracji, reklamacje co do sposobu i zakresu świadczenia usługi można składać mailowo na warunkach opisanych w Regulaminie.
                </li>
                <li>
                  Korzystanie z Serwisu, za wyjątkiem przeglądania umieszczonych w nim Treści i reklam wymaga rejestracji, której Użytkownicy dokonują na zasadach wskazanych w Regulaminie, oraz uwzględnienia określonych w Regulaminie zasad umieszczania i przechowywania Treści.
                </li>
                <li>
                  Usługodawca nie udziela gwarancji, w zakresie dostępności Serwisu jak i dostarczanych informacji będzie świadczyć usługę ze zwykłą starannością.
                </li>
                <li>
                  Serwis jest przedsięwzięciem społecznościowym. Jarock Sp. z o.o. nie zamawia, nie dokonuje analizy redakcyjnej Treści, a zatem każdemu Użytkownikowi Serwisu przysługuje prawo do wykorzystywania udostępnianych w nim Treści tylko i wyłącznie w zakresie dozwolonego użytku osobistego. Postanowienia ustawy z dnia 4 lutego 1994 r. o prawie autorskim i prawach pokrewnych (tekst jednolity Dz.U. z 2019 r. poz. 1231, ze zm.) mają w tym zakresie zastosowanie.
                </li>
                <li>
                  Z chwilą kliknięcia linku aktywującego przesłany na adres e-mail Użytkownika podany w ścieżce rejestracji zostaje zawarta Umowa, a użytkownik Internetu staje się Użytkownikiem Serwisu.
                </li>
                <li>
                  Serwis oraz zawarte w nim materiały oznaczone jako pochodzące od JaRock Sp. z o. stanowią własność JaRock Sp. z o.o., z wyłączeniem:
                  <ol type={"a"}>
                    <li>treści pochodzących od Użytkowników,</li>
                    <li>materiałów pochodzących od innych producentów, dystrybutorów i usługodawców.</li>
                  </ol>
                </li>
                <li>
                  Z Serwisu mogą korzystać osoby:
                  <ol type={"a"}>
                    <li>Użytkownicy w pełnym zakresie,</li>
                    <li>inni użytkownicy Internetu, którzy są uprawnieni jedynie do przeglądania zawartości Serwisu.</li>
                    <li>
                      Użytkownicy oraz użytkownicy Internetu przeglądający Serwis przyjmują do wiadomości, że ze względu na umieszczenie Serwisu w strukturze portalu Ja, Rock! ma do nich zastosowanie Regulamin Świadczenia Usług przez JaRock Sp. z o.o., który jest akceptowany w momencie uruchomienia Stron portalu a publikowany w stopce każdej strony portalu.
                    </li>
                  </ol>
                </li>
                <li>
                  Użytkownik ma prawo do:
                  <ol type={"a"}>
                    <li>przeglądania Serwisu,</li>
                    <li>Korzystania z modułu chatu dostępnego w Serwisie</li>
                    <li>Publikowania filmów i Komentarzy zgodnie z Regulaminem.</li>
                  </ol>
                </li>
                <li>
                  Z chwilą zamieszczenia informacji w Serwisie, Użytkownik oświadcza, że zapoznał się z Regulaminem i zrozumiał jego treść, w tym w szczególności zapisy dotyczące odpowiedzialności za naruszenie prawa i zasad współżycia społecznego.
                </li>
                <li>
                  JaRock Sp. z o.o. oświadcza, a Użytkownik przyjmuje do wiadomości, że wszelkie czynności w ramach Serwisu Użytkownik podejmuje we własnym imieniu w szczególności z uwagi na hostingowy charakter Serwisu, JaRock Sp. z o.o. nie ponosi odpowiedzialności za:
                  <ol type={"a"}>
                    <li>
                      Treści Użytkowników (w tym w szczególności nie zamawia, nie zleca ich przygotowywania, nie dokonuje analizy redakcyjnej czy też autoryzacji przed publikacyjnej),
                    </li>
                    <li>
                      Treści przekazywane i publikowane na łamach Serwisu przez Użytkowników, m.in. za ich prawdziwość, rzetelność oraz autentyczność fotografii, o ile zablokuje do nich dostęp w trybie i na warunkach określonych w prawie polskim,
                    </li>
                    <li>
                      Zdarzenia i wydarzenia, jakie mogą mieć lub miały miejsce w świecie rzeczywistym pomiędzy Użytkownikami zapoznanymi za pośrednictwem Serwisu i to z jakichkolwiek przyczyn,
                    </li>
                    <li>
                      autentyczność informacji i danych podawanych przez Użytkowników do Serwisu lub informacji o Użytkownikach udostępnianych innym Użytkownikom,
                    </li>
                    <li>
                      szkody powstałe w wyniku ingerencji osób trzecich, wadliwego działania czynników zewnętrznych oraz innych systemów (np. sieci telekomunikacyjnych) niezależnych od JaRock Sp. z o.o.,
                    </li>
                    <li>
                      udostępnienie hasła i danych podmiotom upoważnionym, na podstawie właściwych przepisów prawa,
                    </li>
                    <li>
                      szkodę wynikającą z dostępu do Konta Użytkownika osób nieuprawnionych, które są konsekwencją okoliczności niezależnych od JaRock Sp. z o.o.,
                    </li>
                    <li>
                      szkody Użytkownika spowodowane zagrożeniami istniejącymi w Internecie, takimi jak przejęcia haseł przez osoby postronne, włamania do systemu, czy zainfekowanie wirusami systemu Użytkownika.
                    </li>
                  </ol>
                </li>
                <li>
                  JaRock Sp. z o.o. informuje i zastrzega sobie prawo do:
                  <ol type={"a"}>
                    <li>
                      stosowania technologii cookies i innych podobnych technologii w celu udostępniania Serwisu i jego funkcjonalności zgodnie z Regulaminem, więcej informacji zawiera polityka prywatności/cookies,
                    </li>
                    <li>
                      okresowego wyłączania dostępności Serwisu w celu jego rozbudowy lub konserwacji,
                    </li>
                    <li>
                      do zablokowania danemu Użytkownikowi bądź grupie użytkowników dostępu do funkcji, takich jak dodawanie Wpisów w module chat i Komentarzy, lub korzystania z Serwisu na czas nieokreślony, w przypadku świadomego lub celowego naruszania Regulaminu, utrudniania pracy obsłudze Serwisu lub korzystania z niego innym Użytkownikom,
                    </li>
                    <li>
                      do odstąpienia od egzekwowania dowolnego punktu Regulaminu, jeżeli naruszenie Regulaminu jest nieznaczne a jego stopień umożliwia takie odstąpienie,
                    </li>
                    <li>
                      usunięcia Wpisów w module chat i Komentarzy, które zawierają zwroty lub określenia powszechnie uznawane za wulgarne — art. 3 Ustawy o języku polskim z dnia 7 października 1999 r. (tekst jednolity Dz. U. z 2019 r. poz. 1480) lub zwroty, lub określenia powszechnie uznawane za obraźliwe, lub mogące naruszać dobra osobiste osób trzecich, oraz takie, które mają charakter reklamy, kryptoreklamy, product placementu, zawierają treści niezgodne z prawem
                    </li>
                    <li>
                      usunięcia Treści w szczególności po otrzymaniu wiarygodnego zgłoszenia co do bezprawności publikowanych przez Użytkownika Treści, Komentarzy lub Wpisów w trybie i na warunkach ustawy o świadczeniu usług drogą elektroniczną z dnia 18 lipca 2002 (tekst jednolity Dz. U z 2019 r. poz. 123 ze zm.).
                    </li>
                  </ol>
                </li>
                <li>
                  Niedopuszczalne jest umieszczanie w Serwisie oraz przekazywanie za jego pośrednictwem Treści i materiałów sprzecznych z obowiązującym prawem i z zasadami współżycia społecznego, treści wulgarnych, obscenicznych i pornograficznych, treści uważanych powszechnie za obraźliwe, naruszających dobra osobiste innych osób, propagujące przemoc, nagannych moralnie, oraz nieuprawnionego korzystania z cudzego wizerunku, naruszających dobre obyczaje i zasady Netykiety.
                </li>
                <li>
                  Niedopuszczalne są jakiekolwiek działania Użytkowników związane z wykorzystywaniem uzyskanych za pośrednictwem Serwisu, informacji dotyczących innych Użytkowników oraz działania polegające na wykorzystaniu jakiejkolwiek funkcji Serwisu do umieszczania w nim lub rozsyłania informacji handlowej (tzw. Spam).
                </li>
                <li>
                  JaRock sp. z o.o. zastrzega sobie prawo do wykorzystywania Serwisu do prowadzenia działalności komercyjnej, reklamowej, ogłoszeniowej wśród Użytkowników, a także wobec osób trzecich.
                </li>
                <li>
                  Działalność Użytkowników Serwisu związana z publikacją Treści, Wpisów w module chat czy Komentarzy nie jest działalnością dziennikarską w rozumieniu ustawy prawo prasowe z dnia 26 stycznia 1984 r. (tekst jednolity Dz. U. z 2018 r. poz. 1914) a jedynie realizacją prawa każdego obywatela do wyrażania własnych poglądów, określonym w art. 54 ust. 1 Konstytucji Rzeczypospolitej Polskiej z dnia 2 kwietnia 1997 r. (Dz. U. z dnia 16 lipca 1997 r. z późn. zm.).
                </li>
              </ol>
              <h2 className={"basic-headline mb-2"}>ODSTĄPIENIE, WYPOWIEDZENIE UMOWY</h2>
              <ol>
                <li>
                  Umowa o świadczenie usług Serwisu zawarta pomiędzy Użytkownikiem a Serwisem może zostać w każdym czasie wypowiedziana przez Użytkownika ze skutkiem natychmiastowym.
                </li>
                <li>
                  Złożenie przez Użytkownika oświadczenia woli w celu rozwiązania umowy następuje w drodze e-maila przesłanego JaRock sp. z o.o. na adres email <a href={"mailto:kontakt@jarock.pl"}>kontakt@jarock.pl.</a>
                </li>
                <li>
                  Niezależnie od powyższego uprawnienia Użytkownikowi będącemu Konsumentem w rozumieniu przepisów Kodeksu Cywilnego przysługuje prawo odstąpienia od umowy o świadczenie usług Serwisu, bez podania przyczyn, w terminie 14 dni od dnia jej zawarcia. Uprawnienie do odstąpienia od umowy Użytkownik wykonuje poprzez złożenie stosownego oświadczenia w formie elektronicznej — mailem wysłanym na podany wyżej adres email.
                </li>
                <li>
                  JaRock Sp. z o.o. zastrzega sobie prawo do rozwiązania Umowy ze skutkiem natychmiastowym, jeżeli:
                  <ol type={"a"}>
                    <li>
                      ze skutkiem natychmiastowym — w przypadku niewykonania lub nienależytego wykonania tej umowy przez Użytkownika, w tym w razie naruszania przez Użytkownika postanowień Regulaminu lub przepisów bezwzględnie obowiązującego prawa- po uprzednim ostrzeżeniu Użytkownika przez JaRock Sp. z o.o., że w przypadku kontynuowania przez Użytkownika naruszeń zawarta z nim umowa o świadczenie usług Serwisu zostanie wypowiedziana — wypowiedzenie umowy może nastąpić, o ile ostrzeżenie to okaże się bezskuteczne.
                    </li>
                    <li>
                      w każdym czasie w przypadku stwierdzenia rażącego łamania Regulaminu przez Użytkownika lub w związku z decyzją o zaprzestaniu udostępniania Serwisu, o czym użytkownik zostanie niezwłocznie poinformowany.
                    </li>
                  </ol>
                </li>
                <li>
                  Sprzedaż nazwy Konta uprawnień do korzystania z jego funkcjonalności przez Użytkownika jest zabroniona i będzie traktowana jak rażące naruszenie Regulaminu skutkujące zablokowaniem Konta oraz odpowiedzialnością cywilną i karną.
                </li>
                <li>
                  Wygaśnięcie zawartej pomiędzy Użytkownikiem, a JaRock Sp. z o.o. umowy o świadczenie usług Serwisu wiąże się z likwidacją konta Użytkownika i wyrejestrowaniem Użytkownika z Serwisu.
                </li>
                <li>
                  Z chwilą wygaśnięcia umowy o świadczenie usług Serwisu na skutek jej wypowiedzenia, Treści umieszczone w Serwisie przez Użytkownika zostają z niego usunięte, o ile Użytkownik zażąda ich usunięcia mailem wysłanym do JaRock Sp. z o.o. na adres email <a href={"mailto:kontakt@jarock.pl"}>kontakt@jarock.pl</a> — z tym zastrzeżeniem, że w uzasadnionych przypadkach, w szczególności w razie wątpliwości co do respektowania przez Użytkownika postanowień Regulaminu, JaRock Sp. z o.o. przysługuje prawo zachowania dla celów dowodowych kopii umieszczonych przez Użytkownika Treści przed ich usunięciem ze strony internetowej Serwisu. W przypadku niezwrócenia się przez Użytkownika z żądaniem usunięcia Treści z Serwisu mogą być one nadal, bezterminowo przechowywane w Serwisie.
                </li>
                <li>
                  Usunięcie z Serwisu danych osobowych Użytkownika odbywa się w powyższym wypadku z uwzględnieniem aktualnie obowiązujących przepisów prawa.
                </li>
              </ol>
              <h2 className={"basic-headline mb-2"}>REJESTRACJA</h2>
              <ol>
                <li>
                  Warunkiem korzystania z Usługi jest:
                  <ol type={"a"}>
                    <li>rejestracja Użytkownika w tym podanie danych osobowych,</li>
                    <li>akceptacja Regulaminu oraz Polityki prywatności,</li>
                  </ol>
                </li>
                <li>
                  Użytkownik przyjmuje do wiadomości (i wyraża zgodę), że sam zarządza danymi, jakie wprowadza do profilu Użytkownika, w tym między innymi, decyduje o ich wpisaniu, udostępnieniu szerszej publiczności w Serwisie.
                </li>
                <li>
                  Podane przez Użytkownika dane a ujawnione na profilu są informacjami jawnymi co w szczególności oznacza, że mogą dostępne dla osób korzystających z sieci Internet, indeksowane przez wyszukiwarki.
                </li>
                <li>
                  W ramach rejestracji Użytkownik podaje:
                  <ol type={"a"}>
                    <li>adres e-mail,</li>
                    <li>nick (unikalną nazwę użytkownika),</li>
                    <li>hasło.</li>
                  </ol>
                </li>
                <li>
                  JaRock Sp. z o.o. zastrzega sobie prawo do:
                  <ol type={"a"}>
                    <li>
                      odmowy przypisania Użytkownikowi określonej nazwy użytkownika w Serwisie w przypadku, gdy ciąg znaków składający się na Nick jest już przypisany do innego Użytkownika,
                    </li>
                    <li>
                      zmiany przydzielonego Użytkownikowi Nicka w Serwisie ze względów bezpieczeństwa lub programowych w szczególności, gdy Nick jest wyrażeniem wulgarnym, niestosownym lub daną identyfikującą inną osobę (w szczególności nazwisko, numer komunikatora, pseudonim artystyczny, nazwa historyczna).
                    </li>
                  </ol>
                </li>
                <li>
                  Rejestracja jest równoznaczna z wyrażeniem zgody na otrzymywanie wiadomości dotyczących funkcjonowania Serwisu w tym także informacji marketingowych i reklamowych związanych z akcjami i wydarzeniami mającymi miejsce w Serwisie zgodnie z Polityką prywatności.
                </li>
                <li>
                  Po dokonaniu pozytywnego uwierzytelnienia, Użytkownik może dowolnie zarządzać swoim Kontem Użytkownika.
                </li>
                <li>
                  Użytkownik, akceptując Regulamin oświadcza, że:
                  <ol type={"a"}>
                    <li>dane podane w formularzu rejestracji są kompletne i zgodne ze stanem faktycznym;</li>
                    <li>zapoznał się z Regulaminem i Polityką prywatności, i zobowiązuje się ich przestrzegać;</li>
                    <li>posiada on uprawnienia lub zgody wymagane przepisami prawa do tego, aby treści opublikowane na łamach Serwisu, nie spowodowało naruszenia żadnych praw osób trzecich;</li>
                    <li>
                      w przypadku skierowania przez podmioty trzecie jakichkolwiek roszczeń do JaRock Sp. z o.o., odnośnie naruszania jakichkolwiek praw do opublikowanych Treści lub wizerunku osobistego osób trzecich, JaRock Sp. z o.o. dokona na podstawie obowiązującego prawa polskiego zablokowania konkretnych Treści, a Użytkownik zobowiązuje się złożyć odpowiedź na zarzuty podmiotu trzeciego.
                    </li>
                  </ol>
                </li>
              </ol>
              <h2 className={"basic-headline mb-2"}>OBOWIĄZKI I UPRAWNIENIA UŻYTKOWNIKA</h2>
              <ol>
                <li>
                  Użytkownik zobowiązany jest do informowania JaRock Sp. z o.o. o wszelkich zmianach mających wpływ na realizację Umowy, a w szczególności o zmianach danych teleadresowych koniecznych do doręczeń oraz zmianach kontaktowego adresu e-mail pod rygorem skutków doręczenia pism lub wiadomości e-mail wysyłanych na adresy niezaktualizowane.
                </li>
                <li>
                  Użytkownik ma prawo do korzystania z Usługi zgodnie z jej przeznaczeniem.
                </li>
                <li>
                  Konto może być wykorzystywane wyłącznie w sposób zgodny z obowiązującym prawem. Niedopuszczalne jest wykorzystywanie Konta do celów powszechnie uznanych za szkodliwe, niewłaściwe, nielegalne lub niemoralne.
                </li>
                <li>
                  JaRock Sp. z o.o. nie będzie udostępniać danych osobowych Użytkowników Usługi osobom trzecim, za wyjątkiem przypadków określonych przepisami prawa.
                </li>
              </ol>
              <h2 className={"basic-headline mb-2"}>ZABLOKOWANIE KONTA UŻYTKOWNIKA</h2>
              <ol>
                <li>
                  JaRock Sp. z o.o. zastrzega sobie prawo do zablokowania Konta Użytkownik lub funkcjonalności Konta Użytkownika w poszczególnych częściach Serwisu, który w sposób rażący lub uporczywy:
                  <ol type={"a"}>
                    <li>dopuszcza się działań mogących utrudniać lub destabilizować działanie Serwisu,</li>
                    <li>narusza prawnie chronione interesy podmiotów trzecich, w szczególności ich prawa autorskie i dobra osobiste,</li>
                    <li>narusza prawnie chronione interesy podmiotów trzecich, w szczególności ich prawa autorskie i dobra osobiste,</li>
                    <li>zamieszcza wpisy i komentarze będące niezgodne z postanowieniami Regulaminu</li>
                  </ol>
                </li>
                <li>
                  JaRock Sp. z o.o. oświadcza a Użytkownik przyjmuje do wiadomości, że w przypadku uzasadnionych podejrzeń o rażące naruszanie Regulaminu przez Użytkownika np. w wyniku otrzymania wiarygodnej informacji, JaRock Sp. z o.o. może przeprowadzić postępowanie wyjaśniające, w trakcie którego może zbierać informacje z Konta i o Koncie, bez prawa wglądu do korespondencji Użytkownika.
                </li>
                <li>
                  Przez wiarygodną wiadomość o bezprawnym charakterze danych dostarczonych przez Użytkownika i przechowywanych na Koncie lub związanej z nimi działalności rozumie się zwłaszcza, ale nie wyłącznie:
                  <ol type={"a"}>
                    <li>zgłoszenie o otrzymaniu niezamówionej informacji handlowej</li>
                  </ol>
                </li>
              </ol>
              <h2 className={"basic-headline mb-2"}>POUFNOŚĆ</h2>
              <ol>
                <li>
                  Osobiste dane, adresy e-mail będą przekazywane podmiotom trzecim tylko w przypadku wystąpienia okoliczności opisanych w obowiązujących przepisach prawa.
                </li>
                <li>
                  JaRock Sp. z o.o. może zbierać dane dotyczące popularności i zastosowania poszczególnych Usług oferowanych przez JaRock Sp. z o.o., dzieląc się nimi z podmiotami zależnymi od JaRock Sp. z o.o. lub innymi podmiotami powiązanymi. Dane te będą udostępniane tylko anonimowo i grupowo.
                </li>
                <li>
                  Administratorem Danych osobowych Użytkowników Usługi zbieranych oraz przetwarzanych zgodnie z Regulaminem jest JaRock Sp. z o.o.
                </li>
                <li>
                  Podanie danych osobowych jest dobrowolne, aczkolwiek niezbędne dla świadczenia usługi.
                </li>
                <li>
                  Szczegółowy zakres informacji dotyczący przetwarzania danych osobowych Użytkowników znajduje się w Polityce prywatności dostępnej w Serwisie.
                </li>
              </ol>
              <h2 className={"basic-headline mb-2"}>NEWSLETTER</h2>
              <ol>
                <li>
                  Użytkownik może wyrazić zgodę na zamówienie usługi newslettera (subskrypcja wiadomości e-mail). Usługa newslettera polega na okresowym przesyłaniu na podany adres e-mail biuletynu informacyjnego JaRock Sp. z o.o. oraz wiadomości zawierających treści marketingowe (informacje handlowe) i jego partnerów biznesowych (w tym treści dotyczące produktów JaRock Sp. z o.o. i jego partnerów biznesowych oraz Promocji). Subskrypcja newslettera dokonywana jest poprzez zaznaczenie odpowiedniej opcji w formularzu rejestracyjnym lub w terminie późniejszym w Serwisie
                </li>
                <li>
                  Subskrypcja newslettera jest dobrowolna i nieodpłatna. Usługa newslettera świadczona jest przez czas nieoznaczony i Użytkownik może z niej zrezygnować w każdym czasie przez zmianę zgody w Serwisie.
                </li>
              </ol>
              <h2 className={"basic-headline mb-2"}>POSTANOWIENIA KOŃCOWE</h2>
              <ol>
                <li>
                  JaRock Sp. z o.o. zastrzega sobie prawo do przekazania lub zlecenia wszystkich, lub części swoich praw i obowiązków wynikłych z Regulaminu. W takim przypadku procedura wstąpienia podmiotu trzeciego w całość lub część praw i obowiązków wynikających z Umowy odbędzie się na warunkach ogólnie obowiązujących na terenie Rzeczpospolitej Polskiej przepisów prawa a informacja zostanie przesłana w formie mailowej.
                </li>
                <li>
                  JaRock Sp. z o.o. dołoży należytej staranności, aby podmiot, na rzecz którego dokonano zlecenia i/lub przekazania praw, lub obowiązków świadczył Usługi ze starannością ogólnie wymaganą w stosunkach danego rodzaju.
                </li>
                <li>
                  Regulamin może ulec zmianie na warunkach określonych w Regulaminie.
                </li>
                <li>
                  JaRock Sp. z o.o. zastrzega sobie prawo do zmiany Regulaminu w przypadku:
                  <ol type={"a"}>
                    <li>
                      zmiany przepisów prawa regulujących świadczenie usług świadczonych drogą elektroniczną JaRock Sp. z o.o. wpływająca na wzajemne prawa i obowiązki umowy zawieranej pomiędzy użytkownikiem a JaRock Sp. z o.o. lub zmiana interpretacji powyższych przepisów prawa wskutek orzeczeń sądów, decyzji, rekomendacji lub zaleceń właściwych w danym zakresie urzędów, lub organów;
                    </li>
                    <li>
                      zmiany sposobu świadczenia usług drogą elektroniczną spowodowana względami technicznymi lub technologicznymi, biznesowymi lub bezpieczeństwa;
                    </li>
                    <li>
                      zmiany zakresu i/lub świadczenia usług drogą elektroniczną, do których stosują się zapisy Regulaminu poprzez wprowadzenie nowych lub wycofanie przez Serwis dotychczasowych usług.
                    </li>
                  </ol>
                </li>
                <li>
                  O zmianach Regulaminu każdy Użytkownik będzie informowany na 14 dni przed wejściem w życie nowych postanowień Regulaminu, przez JaRock Sp. z o.o. drogą elektroniczną za pomocą jednej z poniższych metod komunikowania się:
                  <ol type={"a"}>
                    <li>
                      mailem przesłanym na adres mailowy podany przez Użytkownika w związku z rejestracją w Serwisie — w takim przypadku zmieniony Regulamin wiąże Użytkownika, jeśli w terminie 7 dni od daty otrzymania powyższej informacji Użytkownik nie oświadczy JaRock Sp. z o.o. — drogą mailową — że nie akceptuje wprowadzonych w Regulaminie zmian. W przypadku złożenia takiego oświadczenia umowa pomiędzy Użytkownikiem a JaRock Sp. z o.o. świadczeniu usług Serwisu ulega rozwiązaniu, konto Użytkownika zostaje zlikwidowane i następuje wyrejestrowanie Użytkownika z Serwisu,
                    </li>
                    <li>
                      w formie wiadomości elektronicznej, która zostanie wyświetlona Użytkownikowi w trakcie logowania się przez niego na swoje konto w Serwisie — w takim przypadku zmieniony Regulamin wiąże Użytkownika, jeśli w terminie 7 dni od daty otrzymania powyższej informacji Użytkownik nie oświadczy JaRock Sp. z o.o. — drogą mailową — że nie akceptuje wprowadzonych w Regulaminie zmian. W przypadku złożenia takiego oświadczenia umowa pomiędzy Użytkownikiem a JaRock Sp. z o.o. o świadczeniu usług Serwisu ulega rozwiązaniu, konto Użytkownika zostaje zlikwidowane i następuje wyrejestrowanie Użytkownika z Serwisu.
                    </li>
                  </ol>
                </li>
                <li>
                  W sprawach nieuregulowanych Regulaminem mają zastosowanie w szczególności przepisy Ustawy o świadczeniu Usług Drogą Elektroniczną oraz Kodeksu Cywilnego.
                </li>
                <li>
                  Wszelkie uwagi, komentarze oraz pytania, dotyczące działania Serwisu należy kierować na adres: <a href={"mailto:kontakt@jarock.pl"}>kontakt@jarock.pl</a>
                </li>
                <li>
                  Regulamin wchodzi w życie wraz z dniem jego publikacji.
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
}